
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import { operateCreditlist } from '@/api/user'
export default {
directives: {
TransferDom
},
components: {
XDialog
},
name: '',
data () {
return {
rule: false,
addressValue: [],
addressid: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
},
mounted () {
this.addCredit()
},
methods: {
fillin () {
this.$router.push({ name: 'chunjie_form' })
},
addCredit () {
/* 添加积分 */
if (this.accountid !== '' && this.accountid != null) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule1',
credit: 1,
owner_type: '2007',
terminaltype: 2
}).then(res => { })
}
}
}
}
